import Loadable from "app/components/Loadable";
import { PERMISSIONS } from "app/utils/permissions";
import { lazy } from "react";

const MarketingOfficerWiseFarmVisitList = Loadable(
  lazy(() => import("./MarketingOfficerWiseFarmVisitList"))
);

const marketingOfficerWiseFarmVisitRoutes = [
  {
    path: "/MarketingOfficerWiseFarmVisit/MarketingOfficerWiseFarmVisitList",
    element: <MarketingOfficerWiseFarmVisitList />,
    permission: PERMISSIONS.MOWiseFarmVisit.Menu,
  },
];
export default marketingOfficerWiseFarmVisitRoutes;
